import './cta.css'
import { useI18n } from '../lib/i18n'
import { Reveal } from '../components/Reveal'
import { CornerBrackets } from '../components/CornerBrackets'
import { Button } from '../components/Button'

// Closing band (DESIGN.md §8 outro): the instrument hands you the verdict and points
// at the door. Special centered glass panel — NOT a standard SectionHeader.
export default function CallToAction() {
  const { lang } = useI18n()
  const C = (
    {
      vi: {
        kicker: '// 09 · SẴN SÀNG',
        titleA: 'Đưa hợp tác xã của bạn ',
        titleEm: 'đạt chuẩn EU',
        sub: 'Một bản đồ ranh giới, một phán quyết minh bạch, một Lot Passport sẵn sàng cho TRACES NT. ARGO lo phần dữ liệu — bạn lo phần cà phê.',
        ctaApp: 'Vào hệ thống ARGO',
        ctaContact: 'Liên hệ hợp tác',
        contactLabel: 'Liên hệ',
      },
      en: {
        kicker: '// 09 · READY',
        titleA: 'Bring your cooperative ',
        titleEm: 'to EU compliance',
        sub: 'One boundary map, one transparent verdict, one Lot Passport ready for TRACES NT. ARGO handles the data — you handle the coffee.',
        ctaApp: 'Enter ARGO',
        ctaContact: 'Partner with us',
        contactLabel: 'Contact',
      },
    } as const
  )[lang]

  return (
    <section id="cta" className="section cta-band">
      <div className="container">
        <Reveal y={28}>
          <div className="cta-inner glass">
            <CornerBrackets size={22} draw className="cta-bracket" />
            <div className="cta-content">
              <h2 className="cta-title">
                {C.titleA}
                <em className="cta-title-em">{C.titleEm}</em>.
              </h2>
              <p className="cta-sub">{C.sub}</p>
              <div className="cta-actions">
                <Button variant="primary" href="/app">
                  {C.ctaApp}
                </Button>
                <Button variant="ghost" href="mailto:kiet922006@gmail.com">
                  {C.ctaContact}
                </Button>
              </div>
              <div className="cta-contact">
                <span className="label cta-contact-label">{C.contactLabel}</span>
                <a className="mono cta-contact-mail" href="mailto:kiet922006@gmail.com">
                  kiet922006@gmail.com
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
